"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.name = exports["default"] = exports.availableProps = void 0;
var _react = _interopRequireDefault(require("react"));
var _selectors = require("../Theme/selectors");
var _template = _interopRequireDefault(require("./template"));
var _excluded = ["color"];
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
var SoccerBall = function SoccerBall(_ref) {
  var color = _ref.color,
    otherProps = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/_react["default"].createElement(_template["default"], _extends({}, otherProps, {
    renderPaths: function renderPaths(uiTheme) {
      var style = {};
      if (color) {
        style.fill = (0, _selectors.getColor)(uiTheme, color);
      }
      return /*#__PURE__*/_react["default"].createElement("path", {
        style: style,
        d: "M6.70417198,15.0214899 C5.50953672,18.2084678 5.52074357,21.6513322 6.61792437,24.7476792 L11.3127413,28.2368082 L10.4615142,30.5196447 C12.9733528,32.7988486 16.1690655,34.0621794 19.4486192,34.1903538 L24.1827542,30.6821107 L26.5146804,32.6182118 C28.8316051,31.4226307 30.7346676,29.6330465 32.0672497,27.4839353 L30.983269,20.7593308 L30.5456885,19.4208494 L33.8803545,17.0124795 C33.281676,14.2289642 31.867931,11.7483431 29.9011935,9.83268983 L22.4015444,9.83268983 L21.0935306,5.84443688 C20.7326307,5.81658059 20.367953,5.80220139 20,5.8018018 L20,5.8043758 C17.0621228,5.80437585 14.2722464,6.70975416 11.9536029,8.30452322 L9.76833977,14.9163449 C9.76833977,14.9163449 7.88344504,15.025408 6.70417198,15.0214899 Z M20,36 C11.163444,36 4,28.836556 4,20 C4,11.163444 11.163444,4 20,4 C28.836556,4 36,11.163444 36,20 C35.9900703,28.8324397 28.8324397,35.9900703 20,36 Z M25.5238095,18.7310167 L23.3075933,25.5469755 L16.1415701,25.5469755 L13.9253539,18.7310167 L19.7245817,14.5173745 L25.5238095,18.7310167 Z"
      });
    }
  }));
};
SoccerBall.defaultProps = {
  color: null
};
var _default = exports["default"] = SoccerBall;
var name = exports.name = 'SoccerBall';
var availableProps = exports.availableProps = ['color'];